import { Stack, styled } from '@mui/material';
import { NEW_COLORS } from '../../../../themes/colors/newColors';

interface SummaryCardContainerProps {
  success?: boolean;
}

export const SummaryCardContainer = styled(Stack, {
  shouldForwardProp: prop => prop !== 'success',
})<SummaryCardContainerProps>(({ success }) => ({
  justifyContent: 'space-between',
  borderRadius: '8px',
  padding: '24px',
  gap: '24px',
  ...(success && {
    background: `linear-gradient(0deg, rgba(82, 135, 44, 0.04), rgba(82, 135, 44, 0.04)), #ffffff`,
    border: `1px solid ${NEW_COLORS.SEMANTICS.SUCCESS[800]}`,
  }),
  ...(!success && {
    backgroundColor: NEW_COLORS.BASE.WHITE,
  }),
}));
